/* eslint-disable react/display-name */

import { Tag } from "antd";
import i18n from "i18n";
import moment from "moment";

const Columns = {};

const renderDataValue = (value) => {
  const style = value ? {} : { color: "#c0c0c0" };
  return <span style={style}>{value || i18n.t("general.none")}</span>;
};

Columns.id = {
  dataIndex: "consulateCategoryId",
  key: "consulateCategoryId",
  title: "#",
  render: (id) => renderDataValue(<div>#{id}</div>),
  width: 80,
};

Columns.createdAt = {
  dataIndex: "createdAt",
  key: "createdAt",
  title: i18n.t("newScreen.createAt"),
  width: 110,
  render: (createdAt) =>
    renderDataValue(
      <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
    ),
};

Columns.title = {
  title: i18n.t("newScreen.title"),
  dataIndex: "title",
  key: "title",
  sorter: true,
  render: (title) => renderDataValue(<div>{title}</div>),
  width: 300,
};

Columns.emoji = {
  title: "Emoji",
  dataIndex: "emoji",
  key: "emoji",
  width: 70,
  render: (emoji) =>
    emoji ? (
      <span style={{ fontSize: 24 }}>{emoji}</span>
    ) : (
      renderDataValue(null)
    ),
};

Columns.isActive = {
  title: "Trạng thái",
  dataIndex: "isActive",
  key: "isActive",
  width: 120,
  render: (isActive) => (
    <Tag color={isActive ? "green" : "red"}>
      {isActive ? "Hoạt động" : "Không hoạt động"}
    </Tag>
  ),
};

export default Columns;
